import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import useReplaceWindowURL from '@/components/Search/hooks/useReplaceWindowURL';
import { SearchSortType } from '@/components/Search/types';
import { sortCriteriaDefaultValue } from '@/components/Search/utils';
import useDebounce from '@/hooks/debounce';

const useSearchSort = (): SearchSortType => {
  const { query } = useRouter();
  const { replaceWindowUrl } = useReplaceWindowURL();
  const initialSortCriteria =
    typeof query.sort === 'undefined'
      ? sortCriteriaDefaultValue
      : Number(query.sort);
  const [sortCriteria, setSortCriteria] = useState(initialSortCriteria);

  const debounceSortCriteria = useDebounce(sortCriteria, 500);

  useEffect(() => {
    replaceWindowUrl({ sort: debounceSortCriteria }).then();
  }, [debounceSortCriteria]);

  return {
    criteria: sortCriteria,
    setCriteria: setSortCriteria,
    debounce: {
      criteria: debounceSortCriteria,
    },
  };
};

export default useSearchSort;
